import { TableBody, TableCell, TableHead, TableRow, Tooltip, Typography, useTheme } from '@mui/material';
import NewList from 'components/new-list';
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { OrderListItem } from 'views/order-feed/features/my-supply-plan/features/ofd-1.0/types/order-list-item.type';

type Props = {
  orderLines: OrderListItem['orderLines'];
};

const PAGE_NAME_ID = 'orderFeed.viewOrder.orderLinesList';

const OrderProductList: React.FC<Props> = ({ orderLines }) => {
  const theme = useTheme();

  return (
    <NewList size="medium" aria-label="Active order body list">
      <TableHead>
        <TableRow>
          <TableCell>
            <Typography color={theme.palette.darkBlue.main} fontWeight="bold" fontSize={12}>
              <FormattedMessage id={`${PAGE_NAME_ID}.itemNameLabel`} />
            </Typography>
          </TableCell>
          <TableCell align="right">
            <Typography color={theme.palette.darkBlue.main} fontWeight="bold" fontSize={12}>
              <FormattedMessage id={`${PAGE_NAME_ID}.orderQuantityLabel`} />
            </Typography>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {orderLines.map((line) => (
          <TableRow key={`${line.itemNumber}_${line.orderQuantity}`} sx={{ fontSize: 14 }}>
            <TableCell component="th" scope="row">
              <Tooltip
                title={`Item Number: ${Number(line.itemNumber)}`}
                sx={{
                  display: 'inline-flex',
                  width: 'fit-content',
                  '& > span': {
                    display: 'inline-flex',
                    width: 'fit-content',
                  },
                }}>
                <Typography fontSize={14}>{line.itemDescription || line.itemName}</Typography>
              </Tooltip>
            </TableCell>
            <TableCell align="right">
              <FormattedNumber value={line.orderQuantity} />
              kg
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </NewList>
  );
};

export default OrderProductList;
